module.exports = __webpack_public_path__ + "static/img/3.575edf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/3.png
// module id = 247
// module chunks = 0